export const QUERY__ORDERS = 'orders';
export const QUERY__USER_ORDERS = 'user-orders';
export const QUERY__ORDER_FULL_INFO = 'order-full-info';
export const QUERY__ORDER_ITEMS = 'order-items';
export const QUERY__EVENT_ORDERS = 'event-orders';
